import { render, staticRenderFns } from "./LLInputCaption.vue?vue&type=template&id=c1f4a672&scoped=true"
import script from "./LLInputCaption.vue?vue&type=script&lang=js"
export * from "./LLInputCaption.vue?vue&type=script&lang=js"
import style0 from "./LLInputCaption.vue?vue&type=style&index=0&id=c1f4a672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f4a672",
  null
  
)

export default component.exports